<template>
  <b-modal
    id="modal-upload-payment-receipt"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    body-class="common_modal modal_visible"
    hide-footer
    style="max-height: 90vh"
    centered
    size="lg"
  >
    <template #modal-header="{ close }">
      <h3 class="m-0">{{ isEdit ? "編輯" : "上傳" }}付款收據</h3>
      <a @click="close()">
        <font-awesome-icon style="font-size: 20px" icon="fas fa-times" />
      </a>
    </template>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form class="mt-1"  @submit.prevent="handleSubmit(onSubmit)">
        <!-- 付款收據編號 -->
        <b-row class="mb-3">
          <b-col md="12">
            <validation-provider
              #default="validationContext"
              name="付款收據編號"
              rules="required"
            >
              <b-form-group
                label="付款收據編號："
                label-for="receipt_number"
                label-cols-md="2"
                class="required"
              >
                <b-input-group>
                  <b-form-input
                    id="receipt_number"
                    v-model="formData.receipt_number"
                    placeholder="請輸入付款收據編號"
                    :state="getValidationState(validationContext)"
                    maxlength="50"
                  />
                  <b-input-group-append>
                  <!-- <b-button
                    variant="outline-primary"
                    @click="getNextPaymentReceiptNumber"
                    :disabled="loadingPaymentReceiptNumber"
                    size="sm"
                  >
                    <b-spinner small v-if="loadingPaymentReceiptNumber" />
                    <span v-else>自動生成</span>
                  </b-button> -->
                </b-input-group-append>
                </b-input-group>
                <!-- <small
                  class="form-text"
                  :class="
                    paymentReceiptNumberValidation.isValid
                      ? 'text-success'
                      : 'text-danger'
                  "
                  v-if="paymentReceiptNumberValidation.message"
                >
                  {{ paymentReceiptNumberValidation.message }}
                </small> -->
              </b-form-group>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </b-col>
        </b-row>

        <!-- 帳單編號 (只讀) -->
        <b-row class="mb-3">
          <b-col md="6">
            <b-form-group
              label="帳單編號："
              label-for="bill_number"
              label-cols-md="3"
            >
              <b-form-input
                id="bill_number"
                v-model="billData.bill_number"
                readonly
                class="bg-light"
              />
            </b-form-group>
          </b-col>

          <!-- 支付金額 (只讀) -->
          <b-col md="6">
            <b-form-group
              label="支付金額："
              label-for="payment_amount"
              label-cols-md="3"
            >
              <b-form-input
                id="payment_amount"
                v-model="formattedPaymentAmount"
                readonly
                class="bg-light"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- 收據日期 -->
        <b-row class="mb-3">
          <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="收據日期"
              rules="required"
            >
              <b-form-group
                label="收據日期："
                label-for="receipt_date"
                label-cols-md="3"
                class="required"
              >
                <flat-pickr
                  id="receipt_date"
                  v-model="formData.receipt_date"
                  :config="datePickerConfig"
                  class="form-control"
                  placeholder="選擇收據日期"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- 收據編號 -->
          <!-- <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="收據編號"
              rules="required"
            >
              <b-form-group
                label="收據編號："
                label-for="receipt_number"
                label-cols-md="3"
                class="required"
              >
                <b-form-input
                  id="receipt_number"
                  v-model="formData.receipt_number"
                  placeholder="輸入收據編號"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col> -->
        </b-row>

        <!-- 備註 -->
        <b-row class="mb-3">
          <b-col cols="12">
            <b-form-group label="備註：" label-for="remark" label-cols-md="2">
              <b-form-textarea
                id="remark"
                v-model="formData.remark"
                placeholder="輸入備註（可選）"
                rows="3"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- 檔案上傳 -->
        <b-row class="mb-3">
          <b-col cols="12">
            <upload-file-single
              v-on:file-uploaded="onFileUploaded"
              file_delete_url="/suppliers/payment-receipts"
              ref="childRef1"
              :props_previewImage="previewImageData"
              :is_required="!isEdit"
              :title="isEdit ? '更新收據' : '付款收據'"
            ></upload-file-single>
          </b-col>
        </b-row>

        <div class="d-flex mt-2 justify-content-end">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            {{ isEdit ? "更新" : "上傳" }}
          </b-button>
        </div>
      </b-form>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BSpinner,
  BRow,
  BCol,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, computed } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import uploadFileSingle from "@/layouts/components/file/uploadFileSingle.vue";
import axiosIns from "@/libs/axios.js";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    BSpinner,
    BRow,
    BCol,
    BFormInvalidFeedback,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    uploadFileSingle,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    billData: {
      type: Object,
      required: true,
    },
    paymentProofData: {
      type: Object,
      required: true,
    },
    paymentReceiptData: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    apiUrl: {
      type: String,
      default: "/suppliers/payment-receipts",
    },
  },
  data() {
    return {
      datePickerConfig: {
        dateFormat: "Y-m-d",
        allowInput: true,
        locale: "zh",
      },
      loadingPaymentReceiptNumber: false,
      paymentReceiptNumberValidation: {
        message: "",
        isValid: true,
      },
    };
  },
  computed: {
    formattedPaymentAmount() {
      return this.paymentProofData.payment_amount
        ? `$${Number(this.paymentProofData.payment_amount).toFixed(2)}`
        : this.billData.bill_total_amount
        ? `$${Number(this.billData.bill_total_amount).toFixed(2)}`
        : "$0.00";
    },
    formData() {
      return {
        receipt_date: this.paymentReceiptData.receipt_date || "",
        receipt_number: this.paymentReceiptData.receipt_number || "",
        remark: this.paymentReceiptData.remark || "",
        file: null,
      };
    },
  },
  watch: {
    "formData.receipt_number": {
      handler: "validatePaymentReceiptNumber",
      immediate: false,
    },
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-upload-payment-receipt");
    },
    onFileUploaded(file) {
      this.formData.file = file;
    },
    // 獲取下一個付款收據編號
    async getNextPaymentReceiptNumber() {
      try {
        this.loadingPaymentReceiptNumber = true;
        this.paymentReceiptNumberValidation = { message: "", isValid: true };

        const response = await this.$store.dispatch(
          "supplier/getNextPaymentReceiptNumber"
        );
        if (response.data && response.data.payment_receipt_number) {
          this.formData.receipt_number =
            response.data.payment_receipt_number;
          this.paymentReceiptNumberValidation = {
            message: "已自動生成編號",
            isValid: true,
          };
        }
      } catch (error) {
        console.error("獲取付款收據編號失敗:", error);
        this.paymentReceiptNumberValidation = {
          message: "獲取編號失敗，請手動輸入",
          isValid: false,
        };
      } finally {
        this.loadingPaymentReceiptNumber = false;
      }
    },
    // 驗證付款收據編號唯一性
    async validatePaymentReceiptNumber() {
      if (!this.formData.receipt_number) {
        this.paymentReceiptNumberValidation = { message: "", isValid: true };
        return;
      }

      try {
        const response = await this.$store.dispatch(
          "supplier/validatePaymentReceiptNumber",
          {
            receipt_number: this.formData.receipt_number,
            exclude_id: this.billData.id,
          }
        );

        this.paymentReceiptNumberValidation = {
          message: response.data.message,
          isValid: response.data.is_unique,
        };
      } catch (error) {
        console.error("驗證付款收據編號失敗:", error);
        this.paymentReceiptNumberValidation = {
          message: "驗證失敗",
          isValid: false,
        };
      }
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();

          formData.append("bill_id", this.billData.id);
          formData.append("payment_proof_id", this.paymentProofData.id || "");
          formData.append("receipt_date", this.formData.receipt_date || "");
          formData.append("receipt_number", this.formData.receipt_number || "");

          formData.append("remark", this.formData.remark || "");

          // 如果是編輯模式，添加 ID
          if (this.isEdit && this.paymentReceiptData.id) {
            formData.append("id", this.paymentReceiptData.id);
          }

          if (this.formData.file) {
            formData.append("file", this.formData.file);
          }

          this.loading = true;

          // 統一使用 POST 方法，後端會根據是否有現有資料來判斷更新或新增
          axiosIns
            .post(this.apiUrl, formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.$bvModal.hide("modal-upload-payment-receipt");
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup(props) {
    const loading = ref(false);
    const formData = ref({
      receipt_date: null,
      receipt_number: "",
      remark: "",
      file: null,
      // 用於 uploadFileSingle 組件的欄位
      id: null,
      name: null,
      file_url: null,
      file_path: null,
      image_url: null,
      image_path: null,
    });

    const resetFormData = () => {
      formData.value = {
        receipt_date: null,
        receipt_number: "",
        remark: "",
        file: null,
        id: null,
        name: null,
        file_url: null,
        file_path: null,
        image_url: null,
        image_path: null,
      };
    };

    // 監聽 props 變化，初始化表單數據
    watch(
      () => props.paymentReceiptData,
      (newData) => {
        if (newData && Object.keys(newData).length > 0) {
          formData.value = {
            receipt_date: newData.receipt_date || null,
            receipt_number: newData.receipt_number || "",
            remark: newData.remark || "",
            file: null,
            // 如果是編輯模式，包含現有檔案資訊（轉換為 uploadFileSingle 組件期望的格式）
            id: newData.id,
            name: newData.receipt_number || "付款收據",
            file_url: newData.payment_receipt_url || null,
            file_path: newData.payment_receipt_path || null,
          };
        } else {
          resetFormData();
        }
      },
      { immediate: true, deep: true }
    );

    // 創建專門用於 uploadFileSingle 組件的預覽資料
    const previewImageData = computed(() => {
      if (formData.value.file_url) {
        return {
          id: formData.value.id,
          name: formData.value.name,
          file_url: formData.value.file_url,
          file_path: formData.value.file_path,
        };
      }
      return null;
    });

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetFormData);

    return {
      loading,
      formData,
      previewImageData,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
